<div
  class="flex flex-wrap items-center justify-between gap-3 mb-3"
  style="margin-top: -10px"
>
  <!-- <h2 class="text-xl font-semibold text-gray-800 dark:text-white/90">
    {{ pageTitle }}
  </h2> -->
  <nav>
    <ol class="flex items-center gap-1.5">
      <!-- Home -->
      <li>
        <a
          class="inline-flex items-center gap-1.5 text-base text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-white transition-colors mt-1 ml-1"
          routerLink="/"
        >
          <i class="pi pi-home"></i>

          <svg
            class="stroke-current"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366"
              stroke=""
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </li>

      @for (crumb of breadcrumbs; track $index) {
        <li>
          @if (crumb.route) {
            <a
              class="inline-flex items-center gap-1.5 text-base text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-white transition-colors"
              [routerLink]="crumb.route"
              [ngClass]="{
                'font-bold underline decoration-dotted underline-offset-4':
                  crumb.highlight,
              }"
            >
              {{ crumb.label }}
              <svg
                class="stroke-current"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366"
                  stroke=""
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
          } @else {
            <span class="text-base text-gray-800 dark:text-white/90">
              {{ crumb.label }}
            </span>
          }
        </li>
      }
    </ol>
  </nav>
</div>
